<div class="order-list">
  <order-tabs [items]="tabs" (selectTab)="onSelectTab($event)" />

  <cx-input-field
    placeholder="Pesquisar por  Número do Pedido, Número da NF ou Código do Cliente"
    [icon]="'search'"
    [iconPosition]="'end'"
  />

  <div class="order-list-container">
    @if (isLoading$ | async) {
      <div class="order-list-container-loading">
        <skeleton-loading class="order-skeleton" />
        <skeleton-loading class="order-skeleton" />
        <skeleton-loading class="order-skeleton" />
        <skeleton-loading class="order-skeleton" />
      </div>
    } @else {
      <div *ngIf="orders$ | async as orders" class="order-list-container-content">
        <div *ngFor="let item of orders">
          <order-item [order]="item" [type]="activeTab" />
        </div>
      </div>
    }
  </div>
</div>

<div class="order-list-pagination">
  <pagination
    [currentPage]="(currentPage$ | async) ?? 1"
    [totalPages]="(totalPages$ | async) ?? 1"
    (changePage)="goToPage($event)"
  ></pagination>
</div>
